export const generateUniqueId = () => {
	const timestamp = new Date().getTime().toString(16);
	const random = Math.random().toString(16).substring(2, 4);
	const uniqueId = `${timestamp}${random}`;

	return uniqueId;
};
